import React, { Component } from 'react';
import './index.css';
import { Badge, Table, Tooltip } from 'antd';

import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../core/reducers';
import { Link, RouteComponentProps } from 'react-router-dom';
import { actionGetReportListEntryMerchant , actionGetReportStatus} from '../../../../core/actions/scanner/report';
import moment from 'moment'
import SearchForm from './searchForm'

interface StateProps {
    reportList: any
    routeKey: any
}

interface DispatchProps {
    getReportList(data): void
    getReportStatus(): void
}

interface RouteState {
    tag: string
}

type TypeProps = StateProps & RouteComponentProps<RouteState>;

class Index extends Component<TypeProps & DispatchProps> {
    
    Columns;
    constructor(props) {
        super(props);
        this.Columns = [
            {
                title: '扫描ID',
                dataIndex: 'examinationReportId',
                key: 'examinationReportId'
            },
            {
                title: '测评店员账号',
                dataIndex: ['examiner', 'mobileNumber'],
                key: 'examiner.mobileNumber'
            },
            {
                title: '设备序列号',
                dataIndex: 'serialNumber',
                key: 'serialNumber',
                ellipsis: {
                    showTitle: false,
                },
                render: (text) => {
                    return (
                        <Tooltip placement="topLeft" title={text}>
                            {text}
                        </Tooltip>
                    )
                }
            },
            {
                title: '用户名称',
                dataIndex: ['examinee', 'nickname'],
                key: 'examinee.nickname'
            },
            {
                title: '客户联系方式',
                dataIndex: ['examinee', 'mobileNumber'],
                key: 'examinee.mobileNumber'
            },
            {
                title: '报告状态',
                render: (record) => {
                    if(record.state === 'COMPLETED') {
                        if(record.valid) {
                            return (
                                <div>
                                    <Badge status="success" /> 报告有效
                                </div>
                            )
                        }
                        else {
                            return (
                                <div>
                                    <Badge status="error" /> 数据无效
                                </div>
                            )
                        }
                    }
                    else if(record.state === 'PROCESSING') {
                        return (
                            <div>
                                <Badge status="processing" /> 处理中
                            </div>
                        )
                    }
                    // return (
                    //     <div>
                    //         <Badge status="error" /> 数据无效
                    //     </div>
                    // )
                }
            },
            {
                title: '创建时间',
                dataIndex: 'creationTimestamp',
                key: 'creationTimestamp',
                // defaultSortOrder: 'descend',
                // sorter: (a, b) => a.creationTimestamp - b.creationTimestamp,
                render: (text) => {
                    if(text) {
                        let time = moment(+text).format('YYYY-MM-DD HH:mm:ss') 
                        return <span>{text && time}</span>
                    }
                }
            },
            {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
                render: (text) => {
                    return <span className="list-reportRemark">{text}</span>
                }
            },
            {
                title: '更多',
                render: (record) => {
                    if(record.state === 'COMPLETED' && record.valid) {
                        let id = record.ticket;
                        let routeKey = this.props.routeKey;
                        let url = `/${routeKey}/reportList/detail/${id}`;
                        return (
                            <Link 
                                to={{
                                    pathname: url,
                                    state: 'back',
                                }} 
                                >查看</Link>
                        );
                        // return <a onClick={() => this.goDetail(record)}>查看</a>;
                    }
                    return <span></span>
                }
            },
        ];
    }

    state = {
        pageNum: 1,
        pageSize: 10,
        examinationReportId: '',
        mobileNumber: '',
        nickname: '',
        serialNumber: '',
    }

    intId;
    componentDidMount () {
        const { history } = this.props;
        let pageNum = 1;
        let pageSize = 10;
        if(history.action === 'POP') {
            let pageSizeLocal = localStorage.getItem('pageSize');
            let pageNumLocal = localStorage.getItem('pageNum');
            if(pageSizeLocal && pageNumLocal) {
                pageSize = +pageSizeLocal;
                pageNum = +pageNumLocal;
            }
            else {
                localStorage.setItem('pageNum', pageNum.toString());
                localStorage.setItem('pageSize', pageSize.toString());
            }
            this.setState({
                pageSize: pageSize,
                pageNum: pageNum
            })
        }
        else {
            localStorage.setItem('pageNum', pageNum.toString());
            localStorage.setItem('pageSize', pageSize.toString());
        }
        let data = {
            pageNum,
            pageSize,
        }
        this.props.getReportList(data);
        this.intId = setInterval(() => {
            this.props.getReportStatus();
        }, 10000);
    }
    
    componentWillUnmount () {
        clearInterval(this.intId);
    }

    onPageChange = (pageNum, pageSize) => {
        const {
            examinationReportId,
            mobileNumber,
            nickname,
            serialNumber,
        } = this.state;
        let page = {
            pageNum: pageNum,
            pageSize: pageSize,
            examinationReportId,
            mobileNumber,
            nickname,
            serialNumber,
        };
        this.setState(page);
        this.props.getReportList(page);
        localStorage.setItem('pageNum', pageNum);
        localStorage.setItem('pageSize', pageSize);
    }

    onShowSizeChange = (pageNum, pageSize) => {
        const {
            examinationReportId,
            mobileNumber,
            nickname,
            serialNumber,
        } = this.state;
        let page = {
            pageNum: pageNum,
            pageSize: pageSize,
            examinationReportId,
            mobileNumber,
            nickname,
            serialNumber,
        };
        this.setState(page);
        this.props.getReportList(page);
        localStorage.setItem('pageNum', pageNum);
        localStorage.setItem('pageSize', pageSize);
    }

    onSearch = (formdata) => {
        const pageSize = this.state.pageSize;
        let data = {
            pageNum: 1,
            pageSize: pageSize,
            ...formdata,
        }
        this.setState(data);
        this.props.getReportList(data);
        localStorage.setItem('pageNum', '1');
        localStorage.setItem('pageSize', pageSize.toString());
    }
    
    onReset = () => {
        const pageSize = this.state.pageSize;
        let data = {
            pageNum: 1,
            pageSize: pageSize,
            examinationReportId: '',
            mobileNumber: '',
            nickname: '',
            serialNumber: '',
        }
        this.setState(data);
        this.props.getReportList(data);
        localStorage.setItem('pageNum', '1');
        localStorage.setItem('pageSize', pageSize.toString());
    }

    render () {

        let data = this.props.reportList || {};
        let list  = data.reportList || [];
        let total = +(data.totalElements || '0');

        return (
            <div className="reportList model">
                <h3 className="margin-bottom-12">报告列表</h3>
                <SearchForm 
                    onSearch={this.onSearch}
                    onReset={this.onReset}
                    />
                <Table 
                    rowKey={(record) => record.examinationReportId}
                    dataSource={list} 
                    columns={this.Columns}
                    pagination={{
                        showSizeChanger: true,
                        total: total,
                        defaultCurrent: this.state.pageNum,
                        current: this.state.pageNum,
                        onChange: this.onPageChange,
                        onShowSizeChange: this.onShowSizeChange,
                        showTotal: total => `总 ${total} 条`
                    }}
                    />
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        reportList: state.report.reportList,
        routeKey: state.user.routeKey,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getReportList: (data) => {
            dispatch(actionGetReportListEntryMerchant(data))
        },
         getReportStatus: () => {
            dispatch(actionGetReportStatus())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)